// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wiggleCart":"_2TXd4","shake":"_1voGU"};